import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { Settings } from 'src/app/app.settings.model';
import { environment } from 'src/environments/environment';
import { AppSettings } from 'src/app/app.settings';
import { UserScope } from '../interfaces/user-scope';
import { Utils } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class ScopeService {

  
  get userScope(): UserScope{
    return JSON.parse(sessionStorage.getItem('userScope'));
  }
  set userScope(item: UserScope){
    if(item){
      sessionStorage.setItem('userScope', JSON.stringify(item));
    } else {
      sessionStorage.removeItem('userScope');
    }
  }

  error:string;
  settings: Settings;
  apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(private http: HttpClient, private appSettings: AppSettings) {
    this.settings = appSettings.settings;
  }

  
  getUserScope() {
    
    return this.http.get<any>(this.apiEndPoint + `AccountApi/GetScope`)
      .pipe(map(result => {
        if(result.Code === 1){
          this.userScope = result.Data;
        }
        return result;
      }));
  }






}
